var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 21.6h0z",
    fill: "none",
    stroke: "#050505",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c-.2 0-.5-.1-.7-.3-1.6-1.5-3.1-2.8-4.4-4l-1-.7c-.8-.7-1.8-1.6-2.6-2.5-1.1-1.3-1.8-2.7-2.1-4.2-.2-.8-.3-2.1-.1-3.4.5-2.6 1.9-4.1 4.4-4.7h.2c.4-.1.8-.2 1.3-.2 1.4 0 2.7.5 4.1 1.4l.1.1c.3.3.6.7.9 1 .2-.3.5-.6.7-.8 1.4-1.3 2.9-1.8 4.6-1.7 2.8.1 5 2.1 5.5 4.8.1.9.1 1.7 0 2.5-.1 1.1-.3 1.9-.8 2.8-.5 1-1 1.9-1.9 2.7-.6.7-1.4 1.4-2.2 2.1-.2.2-.5.4-.7.6l-.1.1-.2.2-.9.8c-1.2 1.1-2.4 2.1-3.5 3.1-.1.2-.4.3-.6.3zM7 4c-.3 0-.5.1-.9.2h-.2c-1.6.4-2.5 1.3-2.8 3.1-.2 1-.1 1.9.1 2.5.3 1.3.8 2.3 1.7 3.4.7.8 1.6 1.6 2.4 2.3l.9.7c1.2 1 2.5 2.2 3.8 3.4.9-.8 1.9-1.7 2.9-2.5l.9-.8.1-.1.2-.2c.2-.2.4-.4.7-.6.7-.6 1.5-1.3 2.1-1.9.7-.7 1.2-1.4 1.5-2.2.3-.7.5-1.3.6-2.2.1-.6.1-1.3 0-2-.3-1.7-1.8-3-3.6-3.1-1.2-.1-2.1.3-3.1 1.2-.3.3-.6.7-.9 1.1 0 .1-.1.1-.1.2-.3.2-.7.5-1.1.5-.6 0-.9-.3-1.1-.5 0 0-.1-.1-.1-.2-.3-.5-.7-.9-1-1.3-1.1-.6-2-1-3-1z",
    fill: "#050505"
  })));
}

export default SvgIconHeart;